<template>
  <div class="job-first" v-for="(item, index) in 3" :key="index">
    <div class="job-first-title" @click="toggleJobContent(index)">
      <div
        class="title-name-item my400 fs24 fc000000"
        v-for="(item, index) in jobInfo"
        :key="index">
        {{ item }}
      </div>
      <div class="title-name-item">
        <img
          src="@/assets/icon/right1.png"
          class="item-right"
          :class="
            lanuchAllAnim[index] == false
              ? 'triangle-img '
              : 'triangle-img-back'
          "
          alt="" />
      </div>
    </div>
    <div class="job-first-content" v-show="jobContentShow[index]">
      <div class="job-responsibility">
        <div class="respon-title my600 fs22 fc000000">岗位职责</div>
        <div class="respon-list my400 fs20 fc000000">
          <div class="respon-item">
            1、负责移动端APP的首页、商业化等核心模块的体验设计，基于产品战略输出高质量设计方案；
            <br />
            2、主导制定移动端产品U及交互设计规范，保证产品的用户体验一致性；<br />
            3、对UX的理解深入，能站在用户角度理解用户需求，围绕用户诉求做体验设计；<br />
            4、基于对业务的深入理解，数据的分析、行业竞品的调研，输出具有突破创新性的行业解决方案。
          </div>
        </div>
      </div>
      <div class="job-require">
        <div class="respon-title my600 fs22 fc000000">岗位要求</div>
        <div class="respon-list my400 fs20 fc000000">
          <div class="respon-item">
            1、本科及以上设计相关专业，5年以上移动端UX设计经验； <br />
            2、有敏锐的用户痛点捕捉能力，能发现现有产品的体验问题并提出解决方案；<br />
            3、具备出色的UI能力、扎实的设计理论和审美水平，能输出高质量的设计方案；<br />
            4、具备较好的数据分析能力、竞品分析、用户调研能力，并基于前期研究输出合理的结论；<br />
            5、较好的业务深入理解和研究能力，对业务有独立的思考和推动能力，能基于用户理解和业务推动产品的发展；<br />
            6、能熟练运用Figma、MasterGo、Al等相关设计软件，并能与产品经理、研发团队进行良好沟通。
          </div>
        </div>
      </div>
      <div class="join-us-btn my600 fs18 fc000000">立即加入</div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, onBeforeUnmount } from "vue";

  const jobInfo = ref(["行政", "杭州", "2025/5"]);
  const jobCount = 3;
  const jobContentShow = ref(Array(jobCount).fill(false));
  const lanuchAllAnim = ref(Array(jobCount).fill(true));

  const toggleJobContent = (index) => {
    jobContentShow.value[index] = !jobContentShow.value[index];
    lanuchAllAnim.value[index] = !lanuchAllAnim.value[index];
  };
</script>
<style lang="less" scoped>
  .job-first {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    .job-first-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      width: 100%;
      height: 82px;

      .title-name-item {
        width: 394px;
        height: 82px;
        line-height: 82px;
        text-align: center;
        cursor: default;

        .item-right {
          width: 15px;
          height: 25px;
          cursor: pointer;
        }

        .triangle-img {
          animation: rotate-triangle 0.2s ease;
          animation-fill-mode: forwards;
        }

        .triangle-img-back {
          animation: rotate-triangle-back 0.2s ease;
          animation-fill-mode: forwards;
        }
      }
    }

    .job-first-content {
      padding: 40px 0 40px 160px;
      width: 100%;
      background: rgba(245, 245, 245, 0.6);

      .respon-list {
        margin-top: 10px;
      }

      .job-require {
        margin-top: 20px;

        .respon-list {
          margin-top: 10px;
        }
      }

      .join-us-btn {
        margin-top: 30px;
        width: 166px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #c9ff85;
        border-radius: 10px 10px 10px 10px;
      }
    }
  }
</style>
